"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Autocomplete = void 0;
var react_1 = __importDefault(require("react"));
var ExpandMore_1 = __importDefault(require("@material-ui/icons/ExpandMore"));
var styles_1 = require("@material-ui/core/styles");
var Autocomplete_1 = __importDefault(require("@material-ui/lab/Autocomplete"));
var TextField_1 = require("../TextField");
var useStyles = styles_1.makeStyles(function (_a) {
    var palette = _a.palette;
    return styles_1.createStyles({
        option: {
            alignItems: "flex-start",
            padding: "0px 30px 6px 30px",
            color: "#0F2440",
            '&[aria-selected="true"]': {
                color: palette.primary.main,
                backgroundColor: palette.common.white,
            },
            "&:hover": {
                backgroundColor: palette.common.white,
            },
        },
        noOptions: {
            alignItems: "flex-start",
            padding: "6px 30px",
            color: "#0F2440",
        },
        input: {
            fontFamily: "Gilroy",
            fontSize: 16,
            lineHeight: "20px",
            background: palette.common.white,
            color: "#0F2440",
            paddingLeft: "21px !important",
        },
        popupIndicator: {
            marginRight: 14.5,
        },
    });
});
exports.Autocomplete = function (_a) {
    var options = _a.options, others = __rest(_a, ["options"]);
    var classes = useStyles(__assign({ options: options }, others));
    return (react_1.default.createElement(Autocomplete_1.default, __assign({ classes: classes }, others, { options: options, renderInput: function (params) { return react_1.default.createElement(TextField_1.TextField, __assign({}, params, { fullWidth: true })); }, popupIcon: react_1.default.createElement(ExpandMore_1.default, null), closeText: "", openText: "" })));
};
